export const ATALASLIT_LIBRARY: string = 'atalskit'

export const LIBRARY_NAME: string = ATALASLIT_LIBRARY

export class BaseProps {
  libraryType?: string = 'atalskit'
}
